import { useCallback } from 'react';
import useTranslationInfo from '../../utils/useTranslationInfo';
import { setLocalStorageLanguage } from '../../utils/localStorage';

const useSelectLanguage = ({ courseId, courseLanguage, availableLanguages = [] }) => {
  const {
    selectedLanguage,
    updateSelectedLanguage,
  } = useTranslationInfo(courseId);

  const setSelectedLanguage = useCallback((newSelectedLanguage) => {
    setLocalStorageLanguage(courseId, newSelectedLanguage);
    updateSelectedLanguage(newSelectedLanguage);
  });

  const isValidSelectedLanguage = availableLanguages.some(lang => lang.code === selectedLanguage);
  const validLanguage = isValidSelectedLanguage ? selectedLanguage : courseLanguage;

  if (!isValidSelectedLanguage) {
    setLocalStorageLanguage(courseId, validLanguage);
  }

  return {
    selectedLanguage: validLanguage,
    setSelectedLanguage,
  };
};

export default useSelectLanguage;
